/* eslint-disable */
/**
 * Universal Player TDX reads auth from `window.piSession`.
 * In local standalone testbed flows, host shell may not initialize it.
 */
export function ensurePiSessionForStandalone(fallbackToken, forceReplace = false) {
  if (typeof window === 'undefined') return false;

  const tokenFromEnv = process.env.REACT_APP_PI_SESSION_TOKEN ? process.env.REACT_APP_PI_SESSION_TOKEN.trim() : '';
  const resolvedToken = fallbackToken || tokenFromEnv;
  if (!resolvedToken) return false;

  try {
    const currentToken = window.piSession?.currentToken?.();
    if (!forceReplace && currentToken && currentToken.length > 0) return;
  } catch (err) {
    // Replace a broken/partial piSession object below.
  }

  const Success = 0;

  window.piSession = {
    Success,
    currentToken: () => resolvedToken,
    getToken: (callback, _minValidity, _maxWait) => {
      queueMicrotask(() => {
        callback(Success, resolvedToken);
      });
    },
    userId: () => '96f269fd96a24b4c96421d72c6f1082e',
    getAccessToken: async () => resolvedToken
  };
  return true;
}
